import { HTTP } from "@/http-common";
import { Dealer } from "@/models/Dealer";
import { createHelpers } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";

export const { mapFields: mapDealerFields } = createHelpers({
  getterType: `dealer/getField`,
  mutationType: `dealer/updateField`
});

const state = {
  dealer: new Dealer()
};

const actions = {
  resetDealer({ commit }) {
    commit("setDealer", new Dealer());
    commit("addDealers", [new Dealer()]);
  },
  getDealer({ commit, dispatch, rootState }) {
    dispatch("message/reset", null, { root: true });

    var response = HTTP.post("dealerportal/getDealer");
    response
      .then(function(data) {
        var resultData = data.data;
        commit("setDealer", resultData);
      })
      .catch(err => {
        dispatch(
          "message/setMessage",
          new httpError({
            message: "Error in getting dealers : " + err.message,
            httpStatus: 500
          }),
          { root: true }
        );
      });
  },
  addDealer({ state, commit }) {
    commit("setDealer", state.dealer);
  }
};

const mutations = {
  setDealer(state, dealer) {
    state.dealer = dealer;
  },

  updateField
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
